import React from "react";

import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Header.css";

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Assapora l'Invisibile" />
      <h1 className="app__header-h1">La Chiave della Cucina Raffinata</h1>
      <p className="p__opensans" style={{ margin: "2rem 0" }}>
        Un'esperienza di alta cucina indimenticabile non riguarda solo il cibo, ma anche l'atmosfera,
        il servizio e l'attenzione ai dettagli.
        La cucina raffinata è una forma d'arte che celebra la creatività culinaria, dove ogni pasto è un viaggio.
      </p>
      <button type="button" className="custom__button">
        Esplora il Menu
      </button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header_img" />
    </div>
  </div>
);

export default Header;